module.exports = __webpack_public_path__ + "static/fonts/Arita-dotumSB.e751fb2.otf";